export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9795.8b09f342.jpg";